import OpenDematFloatBannerCtaClient from "./OpenDematFloatBannerCtaClient";
import OpenDematFloatBannerDesktopShell from "./OpenDematFloatBannerDesktopShell";
import OpenDematFloatBannerVisibilityClient from "./OpenDematFloatBannerVisibilityClient";
import type { OpenDematFlowBannerProps } from "./OpenDematFloatBanner.types";

const OpenDematFloatBanner = (props: OpenDematFlowBannerProps) => {
  const {
    low_brokerage_img,
    floatingBannerMainText,
    floatingBannerSubText,
    brokerageMainText,
    loadOnPageLoad = false,
    isPdp = false,
  } = props;
  const bannerImageLoading = loadOnPageLoad ? "eager" : "lazy";
  const bannerImageFetchPriority = loadOnPageLoad ? "high" : "auto";

  return (
    <OpenDematFloatBannerVisibilityClient
      floatingBannerMainText={floatingBannerMainText}
      brokerageMainText={brokerageMainText}
      loadOnPageLoad={loadOnPageLoad}
      isPdp={isPdp}
    >
      <OpenDematFloatBannerDesktopShell isPdp={isPdp}>
        <div className="w-[235px] shrink-0 bg-[#eff2ff]">
          <img
            src={low_brokerage_img}
            alt="Low brokerage by Bajaj Broking"
            width={235}
            height={73}
            sizes="235px"
            loading={bannerImageLoading}
            fetchPriority={bannerImageFetchPriority}
            className="h-full w-full object-cover"
            draggable={false}
            style={{ background: "#f3f6fc", borderRadius: "4px" }}
          />
        </div>

        <div className="flex flex-shrink flex-grow items-center justify-between bg-white px-6 py-4">
          <div className="text-container fw-500">
            <div className="text-base font-[500] text-black">
              {floatingBannerMainText ??
                "Start your trading journey with Bajaj Broking"}
            </div>
            <div className="text-xs font-[500] text-gray-600">
              {floatingBannerSubText ??
                "Trade easily in stocks, futures & options and IPOs"}
            </div>
          </div>

          <OpenDematFloatBannerCtaClient
            {...props}
            showCtaPadding={props.showCtaPadding ?? true}
          />
        </div>
      </OpenDematFloatBannerDesktopShell>

      <div className="z-9 fixed bottom-[80px] right-[20px] block md:hidden">
        <OpenDematFloatBannerCtaClient
          {...props}
          isFloating={true}
          showCtaPadding={false}
        />
      </div>
    </OpenDematFloatBannerVisibilityClient>
  );
};

export default OpenDematFloatBanner;
